export default __webpack_public_path__ + "static/curriculum-guide-preview-1-943eb4d20aa5cb628daf80cc35baa28f.jpg";